module.exports = __webpack_public_path__ + "assets/img/kaoqin.68e693e8.png";